module.exports = __webpack_public_path__ + "static/media/mobile_play.de7ba79a.svg";